import React from "react"

import Section from "../components/section"
import Layout from "../components/layout"

const ContactPage = () => (
  <Layout>
    <Section>
      <h2>Contact RüDev</h2>
      <p>Ryan loves to hear from new people!</p>
      <p>Drop him a line at: <a href="mailto: ryan@ruedev.com">ryan@ruedev.com</a></p>
      <p>Or at any of these social media platroms:</p>
    </Section>
  </Layout>
)

export default ContactPage
